<div class="cms-container">
  <router-outlet></router-outlet>
</div>
